import { node } from "~/util/dom";
import Content from "./content";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import { store } from "~/state/store";
import { unsetDetail } from "~/state/detail/state";

/**
 * @class Název typu
 * @private
 */
export default class TypeName extends Content {
	_build() {
		this._dom.container.classList.add("content-typename");

		if (this._data.typeName === _("detail.content.typename")) {
			return;
		}

		const makeSearchLink = this._data.typeNameSearchable === undefined
			? this._data.source !== "wcam"
			: !!this._data.typeNameSearchable;
		const h2 = node("h2");

		this._dom.container.appendChild(h2);

		if (makeSearchLink) {
			const link = node("a", {
				href: `${CONFIG.mapyURL}/?q=${encodeURIComponent(this._data.typeName)}&cat=1`,
				innerHTML: this._data.typeName,
			});

			// middle click - otevrit v novem okne
			link.addEventListener("click", event => {
				if (Mapy.Util.linkToNewWindow(event)) {
					return;
				}

				event.preventDefault();
				store.dispatch(unsetDetail());
				Mapy.getComponent("search").activate().setState({
					q: this._data.typeName,
					cat: 1,
					searchOrigin: "detail_poitype",
				});
				Mapy.getComponent("history").save();
			});
			h2.appendChild(link);
		} else {
			// pouze text
			h2.append(node("span", { textContent: this._data.typeName }));
		}
	}
}
